export const round = (n: number, decimals = 2) =>
  Number((Math.round((n + Number.EPSILON) * 10 ** decimals) / 10 ** decimals).toFixed(decimals));

export const pickAccumulated = (ahorroAcumulado: number | undefined, amortized: unknown, decimals = 2, eps = 0) => {
  const base = Number(ahorroAcumulado ?? 0);
  const amo = Number(amortized);
  if (!Number.isFinite(amo)) return round(base, decimals);
  const baseR = round(base, decimals);
  const amoR = round(amo, decimals);
  return Math.abs(amoR - baseR) >= eps ? amoR : baseR;
};
